// extracted by mini-css-extract-plugin
export default {"main":"Pagination_main__tIHGQ","buttons":"Pagination_buttons__nKV8a","inactive":"Pagination_inactive__xpJpi","active":"Pagination_active__W0aUf","arrow":"Pagination_arrow__E0FGV"};